import API from '../app.api';
import ApiResources from '../../helpers/APIResource';
import store from '../../helpers/Store';

export const getReportOptions = async () => {
    try {
        const res = await API.get('/api/v1/federated/report/as400/report-option');
        ApiResources.hydrateResource(res.data);
        return res.data;
    } catch (err) {
        console.log('Error trying to get KPI data from API: ', err);
        return null;
    }
};
